// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fill-color"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11.9999 21.4853L20.4852 13H3.51465L11.9999 21.4853Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.9999 4.51491L20.4852 13.0002L11.9999 21.4855L3.51465 13.0002L11.9999 4.51491ZM11.9999 4.51491L9.52506 2.04004M19.9499 13H4.24991","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.2197 21.0095C20.5126 21.3795 20.9874 21.3795 21.2803 21.0095C21.5732 20.6396 21.5732 20.0398 21.2803 19.6698L20.75 19L20.2197 19.6698C19.9268 20.0398 19.9268 20.6396 20.2197 21.0095Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FillColorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fill-color',
    ref,
    icon: element,
  },
));

FillColorIcon.displayName = 'FillColorIcon';

export default FillColorIcon;
